import config from '../../config';
import { authHeader, handleResponse } from '../../_helpers';
import { encData } from '../../_helpers/_helperFunctions';
export const subDepartmentService = {
    getAll,
    getSubDepartmentById,
    create,
    update,
    deleteSubDepartment
};

function getAll() {
    const requestOptions = { method: 'GET', headers: authHeader()};
    console.log("requestOptions: ", requestOptions)
    return fetch(`${config.apiUrl}/api/v1/sub-departments`, requestOptions).then(handleResponse);
}

function getSubDepartmentById(id) {
    const requestOptions = { method: 'GET', headers: authHeader() };
    return fetch(`${config.apiUrl}/api/v1/sub-departments/${id}`, requestOptions).then(handleResponse);
}

function create(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: encData(data)
    };
    return fetch(`${config.apiUrl}/api/v1/sub-departments/create`, requestOptions).then(handleResponse);
}

function update(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: encData(data)
    };
    return fetch(`${config.apiUrl}/api/v1/sub-departments/update`, requestOptions).then(handleResponse);
}

function deleteSubDepartment(departmentId,currentUserId) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: encData({departmentId,currentUserId})
    };
    return fetch(`${config.apiUrl}/api/v1/sub-departments/delete`, requestOptions).then(handleResponse);
}